import { render, staticRenderFns } from "./QuizQuestionShortAnswerV2.vue?vue&type=template&id=df248828&scoped=true"
import script from "./QuizQuestionShortAnswerV2.vue?vue&type=script&lang=js"
export * from "./QuizQuestionShortAnswerV2.vue?vue&type=script&lang=js"
import style0 from "./QuizQuestionShortAnswerV2.vue?vue&type=style&index=0&id=df248828&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df248828",
  null
  
)

export default component.exports